import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/groups/BuiltInGroupsResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/defaultgroups`;
	}
	list() {
		return this.api.get(n.baseUrl);
	}
};
//#endregion
export { n as BuiltInGroupsResource };

//# sourceMappingURL=BuiltInGroupsResource.js.map